import { useEffect, useState } from "react";
import { IPanelCrearTipoEquipo } from "./PanelCrearTipoEquipo";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { ITipoEquipoBody } from "../../../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";
import TipoEquipoService from "../../../../../services/ListaVerificacion/TipoEquipoService";

export const UsePanelCrearTipoEquipo=(props:IPanelCrearTipoEquipo)=>{
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const inital:ITipoEquipoBody={
        codigo: "",
        nombre:"",
    }
    const [request,setRequest]=useState<ITipoEquipoBody>(inital)
    const reset=()=>{
        setMensaje("")
        setLoading(false)
        setRequest(inital)
        setStatus(0)
        props.onDismiss()
    }
    const required: (keyof ITipoEquipoBody)[] = [
        "nombre",
        "codigo",
      ];
    useEffect(()=>{
        const check = required.every((field) => {
            const value = request[field];
            return value !== null && value !== undefined && value !== "";
          });
        setDisableForm(!check)
    },[request])
    const postInsertarTipoEquipo=()=>{
        setLoading(true)
        TipoEquipoService.CrearAuxiliar(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,postInsertarTipoEquipo,loading,disableForm,reset,mensaje,status}

    


}